import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';

/**
 * Angular version of cl-button from AngularJS side
 * This is duplicated rather than replaced in order to 'phase-out' the old button as is convenient,
 * as converting it all at once would be a huge job -- lots of icons that would have to be re-registered
 */

@Component({
    encapsulation: ViewEncapsulation.None, // there are styles for this in normal external stylesheets
    selector: 'cas-form-field-input',
    template: `
        <mat-form-field>
            <input
                matInput
                type="text"
                [(ngModel)]="model"
                (keyup)="onKey($event)"
            />
        </mat-form-field>`,
})
export class CasFormFieldInputComponent {
    public static $name: string = 'casFormFieldInput';

    @Input() public model: string;
    @Output() public modelChange = new EventEmitter<string>();

    onKey(_: KeyboardEvent) {
        this.modelChange.emit(this.model);
    }
}
